<div class="modal-work-schedule" *ngIf="open">
  <div class="modal-container">
    <div class="modal-header">
      <div class="modal-title">
        <span>Configurar usuário:</span>&nbsp;
        <span *ngIf="users.length === 1">{{ users[0].userLabel }}</span>
        <span *ngIf="users.length > 1">{{ users.length }} corretores selecionados</span>
      </div>
      <button class="close-modal-btn" (click)="closeModal.emit();">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="black"/>
        </svg>          
      </button>
    </div>
    <div class="config-users-content" >
      <div class='options-container'>
        <div class='config-users-options'>
          <span>Mercado primário</span>
          <mat-slide-toggle class="mr-r-20" [checked]="primaryMarkety" (change)="changeActiveStatus($event.checked, 'primaryMarkety')"></mat-slide-toggle>
        </div>
        <div class='config-users-options'>
          <span>Mercado secundário</span>
          <mat-slide-toggle class="mr-r-20" [checked]="secondaryMarkety" (change)="changeActiveStatus($event.checked, 'secondaryMarkety')"></mat-slide-toggle>
        </div>
        <div class="form-inputs" *ngIf="secondaryMarkety">
          <lib-input-checkbox class="input-control" id="favorite" name="favorite" label='Venda' [(ngModel)]="sale"></lib-input-checkbox>
          <lib-input-checkbox class="input-control" id="favorite" name="favorite" label='Localização' [(ngModel)]="location" ></lib-input-checkbox>
        </div>
      </div>
      <div class="modal-footer">
        <lib-button-tertiary id="config-users-cancel-btn" class="footer-btn" (click)="closeModal.emit();">Cancelar</lib-button-tertiary>
        <lib-button-primary id="config-users-save-btn" class="footer-btn" (click)="save()">Salvar</lib-button-primary>
      </div>
    </div>
  </div>
</div>
